module.exports = __webpack_public_path__ + "4db540018e9a72208ba2060aae9ad3d8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/images/logo.png
 ** module id = 1945
 ** module chunks = 73
 **/